import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  @Input({ required: true }) name: IconName;

  get svgPath() {
    return `/assets/icons/${this.name}.svg`;
  }

  get iconStyle() {
    return `--icon-mask: url("${this.svgPath}")`;
  }
}

export type IconName =
  | 'arrow-left'
  | 'arrow-right'
  | 'bank-note-02'
  | 'bar-chart-01'
  | 'box'
  | 'calendar'
  | 'check-verified-03'
  | 'check'
  | 'chevron-down-double'
  | 'chevron-down'
  | 'chevrons-left'
  | 'chevrons-left-circle'
  | 'cube-01'
  | 'dots'
  | 'eye-off'
  | 'eye'
  | 'facebook'
  | 'file-download-02'
  | 'filter-lines'
  | 'globe-01'
  | 'google'
  | 'home-01'
  | 'inbox-01'
  | 'info-circle'
  | 'mail-01'
  | 'menu-01'
  | 'minus'
  | 'package'
  | 'play-square'
  | 'play'
  | 'plus'
  | 'receipt-check'
  | 'refresh-3'
  | 'rocket-02'
  | 'search-sm'
  | 'shield-01'
  | 'star-01'
  | 'target'
  | 'upload-01'
  | 'user-01'
  | 'x-close';
